module.exports = __webpack_public_path__ + "img/xin.a5f8d92b.png";